import { Injectable } from '@angular/core';
import emailjs from '@emailjs/browser';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class EmailService {

  constructor(
    private userService : UserService,
  ) { }

  readonly SERVICE_ID: string = 'service_ggwkn2o';
  readonly TEMPLATE_ID: string = 'template_u5r77cp';

  sendLeadOnEmail(){
     const templateParams = {
      name:this.userService.currentUser.firstName,
      email:this.userService.currentUser.email,
      phone: this.userService.currentUser.mobile,
      company: this.userService.currentUser.companyName,
      products: "EnKash Cards",
      city : "India",
      source:"Freedom Banner",
     };
         
     emailjs.send(this.SERVICE_ID, this.TEMPLATE_ID, templateParams,"user_BjlWRs4gHdZBah1IBle91")
        .then(function(response) {
           console.log('SUCCESS!', response.status, response.text);
        }, function(error) {
           console.log('FAILED...', error);
     });

    }
}
